import { useState } from "react";
import {
  Boton,
  accessAPI,
  formatFecha,
  CampoInformacion,
  Titulo
} from "../../../shared";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

export default function TarjetaJuguetes({ proceso, toast }) {
  const [fechaPago, setFechaPago] = useState(
    formatFecha(proceso.juguetespagodni)
  );

  const [loaderProcesarPago, setLoaderProcesarPago] = useState(false);
  const [loaderConformidad, setLoaderConformidad] = useState(false);
  const [fechaConformidad, setFechaConformidad] = useState(
    formatFecha(proceso.fechaEnvioDNIJuguetesCertificacion)
  );
  const [loaderInspeccion, setLoaderInspeccion] = useState(false);
  const [fechaInspeccion, setFechaInspeccion] = useState(
    formatFecha(proceso.fechaEnvioDNIJuguetesInspeccion)
  );
  const [loaderArchivado, setLoaderArchivado] = useState(false);
  const [fechaArchivado, setFechaArchivado] = useState(
    formatFecha(proceso.fechaArchivadoJuguetes)
  );

  function reportarPagoDNI() {
    setLoaderProcesarPago(true);
    accessAPI(
      "POST",
      `dni/juguetes/confirmarpago/${proceso.id}`,
      null,
      (respuesta) => {
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: respuesta[0]?.msg || "Pago reportado exitosamente"
        });
        setFechaPago(formatFecha(new Date()));
        setLoaderProcesarPago(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Ocurrió un error",
          sticky: true
        });
        setLoaderProcesarPago(false);
      }
    );
  }

  function reportarConformidadDNI() {
    setLoaderConformidad(true);
    accessAPI(
      "POST",
      `dni/juguetes/reportarconformidad/${proceso.id}/1`,
      null,
      (respuesta) => {
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: respuesta[0]?.msg || "Conformidad reportada exitosamente"
        });
        setFechaConformidad(formatFecha(new Date()));
        setLoaderConformidad(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Ocurrió un error",
          sticky: true
        });
        setLoaderConformidad(false);
      }
    );
  }

  function reportarInspeccionDNI() {
    setLoaderInspeccion(true);
    accessAPI(
      "POST",
      `dni/juguetes/reportarconformidad/${proceso.id}/3`,
      null,
      (respuesta) => {
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: respuesta[0]?.msg || "Inspección reportada exitosamente"
        });
        setFechaInspeccion(formatFecha(new Date()));
        setLoaderInspeccion(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Ocurrió un error",
          sticky: true
        });
        setLoaderInspeccion(false);
      }
    );
  }

  function reportarArchivadoDNI() {
    setLoaderArchivado(true);
    accessAPI(
      "POST",
      `dni/juguetes/reportararchivado/${proceso.id}`,
      null,
      (respuesta) => {
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: respuesta[0]?.msg || "Archivado reportado exitosamente"
        });
        setFechaArchivado(formatFecha(new Date()));
        setLoaderArchivado(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Ocurrió un error",
          sticky: true
        });
        setLoaderArchivado(false);
      }
    );
  }

  function desarchivarDNI() {
    setLoaderArchivado(true);
    accessAPI(
      "POST",
      `dni/juguetes/desarchivar/${proceso.id}`,
      null,
      (respuesta) => {
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: respuesta[0]?.msg || "Proceso desarchivado exitosamente"
        });
        setFechaArchivado(null);
        setLoaderArchivado(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Ocurrió un error",
          sticky: true
        });
        setLoaderArchivado(false);
      }
    );
  }

  return (
    <Card>
      <Titulo>Operaciones de juguetes</Titulo>
      {!fechaPago && (
        <Boton
          callback={reportarPagoDNI}
          transparente
          confirmacion="¿Seguro?"
          loader={loaderProcesarPago}
        >
          Reportar pago a DNI
        </Boton>
      )}
      {fechaPago && (
        <CampoInformacion nombreCampo="Proceso pago en">
          {fechaPago}
        </CampoInformacion>
      )}
      <Divider />
      {!fechaConformidad && (
        <Boton
          callback={reportarConformidadDNI}
          transparente
          confirmacion="¿Reportar conformidad a DNI?"
          loader={loaderConformidad}
        >
          Reportar conformidad a DNI
        </Boton>
      )}
      {fechaConformidad && (
        <CampoInformacion nombreCampo="Conformidad reportada en">
          {fechaConformidad}
        </CampoInformacion>
      )}
      <Divider />
      {!fechaInspeccion && (
        <Boton
          callback={reportarInspeccionDNI}
          transparente
          confirmacion="¿Reportar inspección conforme a DNI?"
          loader={loaderInspeccion}
        >
          Reportar inspección conforme a DNI
        </Boton>
      )}
      {fechaInspeccion && (
        <CampoInformacion nombreCampo="Inspección reportada en">
          {fechaInspeccion}
        </CampoInformacion>
      )}
      <Divider />
      {!fechaArchivado && (
        <Boton
          callback={reportarArchivadoDNI}
          transparente
          confirmacion="¿Reportar archivado a DNI?"
          loader={loaderArchivado}
        >
          Reportar archivado
        </Boton>
      )}
      {fechaArchivado && (
        <>
          <CampoInformacion nombreCampo="Archivado en">
            {fechaArchivado}
          </CampoInformacion>
          <Boton
            callback={desarchivarDNI}
            transparente
            confirmacion="¿Desarchivar el proceso?"
            loader={loaderArchivado}
          >
            Desarchivar
          </Boton>
        </>
      )}
    </Card>
  );
}
